import { ProjectDetailData, VendorProjectData } from "@/graphql/fragments";
import { gql } from "@apollo/client";

export const ADD_PROJECT_TO_USER_RECENT_PROJECTS_MUTATION = gql`
  mutation AddProjectToUserRecentProjects($projectId: SmartID!) {
    addProjectToUserRecentProjects(projectId: $projectId) {
      success
      message
    }
  }
`;

export const CURRENT_PROJECT_DETAILS_QUERY = gql`
  query CurrentProjectDetails($projectId: SmartID!) {
    project(id: $projectId) {
      id
      ...ProjectDetail
    }
  }

  ${ProjectDetailData}
`;

export const VENDOR_PROJECT_SEARCH_QUERY = gql`
  query VendorProjectSearch($projectId: SmartID!) {
    vendorProject(id: $projectId) {
      id
      ...VendorProject
    }
  }

  ${VendorProjectData}
`;

export const ProjectSearchResultData = gql`
  fragment ProjectSearchResult on Project {
    id
    isArchived
    hasCompletedTasks
    userNotificationSubscriptions
    projectCategory {
      name
      type
    }
    creator {
      id
      office {
        id
        company {
          id
          profile {
            ... on ClientProfile {
              id
              companyName
            }
            ... on VendorProfile {
              id
              companyName
            }
          }
        }
      }
    }
    name
  }
`;

export const PROJECTS_SEARCH_QUERY = gql`
  query ProjectsSearch(
    $projectSearchTerm: String
    $selectedProjectId: SmartID
    $first: Int
    $after: String
    $showArchived: Boolean
  ) {
    recentProjects(
      selectedProjectId: $selectedProjectId
      projectSearchTerm: $projectSearchTerm
      first: $first
      after: $after
      showArchived: $showArchived
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...ProjectSearchResult
        }
      }
    }
  }

  ${ProjectSearchResultData}
`;

export const VENDOR_PROJECTS_SEARCH_QUERY = gql`
  query VendorProjectsSearch(
    $limit: Int
    $endCursor: String
    $name: String
    $selectedProjectId: ID
  ) {
    vendorProjects(
      first: $limit
      after: $endCursor
      projectName: $name
      selectedProjectId: $selectedProjectId
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...VendorProject
        }
      }
    }
  }

  ${VendorProjectData}
`;
